import createDataContext from './createDataContext';
import { api } from '../api/api';

const stickyProductsReducer = (state, action) => {
	switch (action.type) {
		case 'REQUEST':
			return {
				...state,
				loading: true,
				error: false,
			};
		case 'SUCCESS':
			return {
				...state,
				loading: false,
				stickyProducts: action.payload,
			};
		case 'ERROR':
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

const loadStickyProducts = (dispatch) => async () => {
	try {
		dispatch({
			type: 'REQUEST',
		});
		const response = await api.get('/stickyProducts', {
			headers: {
				Authorization: `Bearer ${localStorage.getItem('token')}`,
			},
		});
		dispatch({
			type: 'SUCCESS',
			payload: response.data,
		});
	} catch (e) {
		dispatch({
			type: 'ERROR',
			payload: 'Unable to load sticky products',
		});
	}
};

export const { Context, Provider } = createDataContext(
	stickyProductsReducer,
	{
		loadStickyProducts,
	},
	{
		stickyProducts: [],
		error: '',
		loading: false,
	}
);
